export default "__VITE_ASSET__635056c5__"